import { create as o } from "zustand";
const x = o((t) => ({
  setOnTextEdit: (e) => t(() => ({
    onTextEdit: e
  }))
}));
export {
  x as useTextboxStore
};
//# sourceMappingURL=index.es103.js.map
